export default __webpack_public_path__ + "static/business-loans-3fb2ac4c7a5b84396fc4d3f93afd5132.png";